import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import {
    withStyles,
    Typography,
    Button,
} from '@material-ui/core';
import theme from '../../app/style/theme';

const styles = () => ({
    root: {
        marginTop: theme.spacing(2),
    },
    active: {
        padding: theme.spacing(2),
        border: theme.borders.dashed,
    },
    centerContainer: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
    },
    link: {
        display: 'flex',
    },
    icon: {
        marginLeft: theme.spacing(1),
        fontSize: 16,
    },
});

const NoContentClickToAdd = ({
    text, linkText, linkTo, classes, active, disabled, readOnly,
}) => (
    <div className={classnames(classes.root, { [classes.active]: active })}>
        <Typography align="center">
            {text}
        </Typography>

        {!readOnly && (
            <div className={classes.centerContainer}>
                <Button component={Link} to={linkTo} color="primary" disabled={disabled}>
                    {linkText}
                </Button>
            </div>
        )}
    </div>
);

NoContentClickToAdd.propTypes = {
    text: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkTo: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

NoContentClickToAdd.defaultProps = {
    active: false,
    disabled: false,
    readOnly: false,
};

export default withStyles(styles)(NoContentClickToAdd);
